const WisdomSpace = {
  //办公室
  path: 'wisdom-space',//慧活空间办公室
  component: () => import("@/views/member/wisdom-space/wisdom-space"),
  meta: {
    tabBar: 'home'
  },
  children: [{
    path: 'space-member',//我的会员
    component: () => import('@/views/member/wisdom-space/space-member'),
    meta: {
      tabBar: false
    },
  },{
    path: 'space-goods',//慧活空间订单
    component: () => import('@/views/member/wisdom-space/space-goods'),
    meta: {
      tabBar: false
    },
  },{
    path: 'space-set',//空间设置
    component: () => import('@/views/member/wisdom-space/space-set'),
    meta: {
      tabBar: false
    },
  },{
      path: 'space-problem',//慧活空间常见问题
      component: () => import('@/views/member/wisdom-space/space-problem'),
      meta: {
        tabBar: false
      },
    },{
    path: 'space-manage',//团队管理
    component: () => import('@/views/member/wisdom-space/space-manage'),
    meta: {
      tabBar: false
    },
  },{
    path: 'space-detail',//收益明细
    component: () => import('@/views/member/wisdom-space/space-detail'),
    meta: {
      tabBar: false
    },
  },{
    path: 'tb-details',//通宝提现详情
    component: () => import('@/views/member/wisdom-space/tb-details'),
    meta: {
      tabBar: false
    },
  },{
    path: 'space-qr-code',//慧活空间二维码
    component: () => import('@/views/member/wisdom-space/space-qr-code'),
    meta: {
      tabBar: false
    },
  }]
};

export default WisdomSpace;
